import { useContext } from 'react';
import { SettingsContext } from './SettingsProvider';

export function useStoreSettings() {
    const settings = useContext(SettingsContext);

    return {
        data: settings.storeSettings ?? [],
        isLoaded: settings.isLoaded ?? false,
        setIsLoaded: settings.setIsLoaded ?? function noRefCheck() {}
    };
}
